<div
  class="overlay"
  #panel
  id="eltopepanel"
  [style.left.px]="overlayLeft"
  [style.width.px]="overlayWidth"
>
  <!--  <app-buttons (save)="submit()" [buttonsWrap]="'panel2'"></app-buttons> -->
  <!-- <mat-icon (click)="save()" class="">save</mat-icon> -->
  <!--  <mat-icon (click)="destroy()" class="dismiss">close</mat-icon> -->
  <ng-template #target></ng-template>
</div>
